import React from 'react';
import CouponManager from './CouponManager';

const Coupons = () => {
  return <CouponManager />;
};

export default Coupons; 